import React, { useState } from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  position: relative;
  width: 100%;

  .search-input {
    width: 100%;
    padding: 5px;
    font-size: 1rem;
    border-radius: 5px;
    border: none;
    outline: none;
  }

  .autocomplete-list {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 1000;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .autocomplete-item {
    padding: 8px;
    cursor: pointer;
    
    &:hover {
      background-color: #f0f0f0;
    }
  }
`;

const SearchAutocomplete = ({ onSelectRoute }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAutocomplete, setShowAutocomplete] = useState(false);

  const searchOptions = [
    // Main navigation routes
    { label: 'Home', route: '/home' },
    { label: 'About', route: '/about' },
  
    { label: 'Nosotros', route: '/es/about' },
    { label: 'Contacto', route: '/es/contact' },
    { label: 'Contact', route: '/contact' },
  
    // Product-related routes
    { label: 'Productos', route: '/es/products' },
    { label: 'Producs', route: '/products' },
  
    // User-related routes
    { label: 'Login', route: '/login' },
  
    // Product specific routes
    { label: 'Coves', route: '/products' },
    { label: 'Codos', route: '/products' },
    { label: 'Beds', route: '/products' },
    { label: 'Casung', route: '/products' },
    { label: 'Stops', route: '/products' },
  
    // Add new words/categories
    { label: 'Molding', route: '/products' },
    { label: 'Moldura', route: '/es/products' },
    { label: 'Wood', route: '/products' },
    { label: 'Madera', route: '/es/products' },
    { label: 'Finish', route: '/products' },
    { label: 'Acabado', route: '/es/products' },
    { label: 'Types', route: '/products' },
    { label: 'Tipos', route: '/es/products' },
    { label: 'Details', route: '/products' },
    { label: 'Detalles', route: '/es/products' },
    { label: 'Quality', route: '/products' },
    { label: 'Calidad', route: '/es/products' },
    { label: 'Sales', route: '/products' },
    { label: 'Ventas', route: '/es/products' },
    { label: 'Delivery', route: '/products' },
    { label: 'Entrega', route: '/es/products' },
    { label: 'Support', route: '/products' },
    { label: 'Soporte', route: '/es/products' },
    { label: 'Materials', route: '/products' },
    { label: 'Materiales', route: '/es/products' },
    { label: 'Catalog', route: '/products' },
    { label: 'Catálogo', route: '/es/products' },
    { label: 'Information', route: '/about' },
    { label: 'Información', route: '/es/about' },
    { label: 'Shipping', route: '/products' },
    { label: 'Envio', route: '/es/products' },
    { label: 'Orders', route: '/products' },
    { label: 'Pedidos', route: '/es/products' },
    { label: 'Product', route: '/products' },
    { label: 'Producto', route: '/es/products' },
    { label: 'Available', route: '/products' },
    { label: 'Disponible', route: '/es/products' },
    { label: 'Quantity', route: '/products' },
    { label: 'Cantidad', route: '/es/products' },
    { label: 'Price', route: '/products' },
    { label: 'Precio', route: '/es/products' },
    { label: 'Availability', route: '/products' },
    { label: 'Disponibilidad', route: '/es/products' },
    { label: 'Add', route: '/products' },
    { label: 'Agregar', route: '/es/products' },
    { label: 'View', route: '/products' },
    { label: 'Ver', route: '/es/products' }
  ];
  

  const filteredOptions = searchOptions.filter(option => 
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowAutocomplete(value.length > 0);
  };

  const handleSelectOption = (option) => {
    setSearchTerm(option.label);
    setShowAutocomplete(false);
    
    // Optional: Call the route selection handler if provided
    if (onSelectRoute) {
      onSelectRoute(option.route);
    }
  };

  return (
    <SearchContainer>
      <input 
        type="text" 
        className="search-input"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={() => setShowAutocomplete(searchTerm.length > 0)}
        onBlur={() => setTimeout(() => setShowAutocomplete(false), 200)}
      />
      {showAutocomplete && filteredOptions.length > 0 && (
        <ul className="autocomplete-list">
          {filteredOptions.map((option, index) => (
            <li 
              key={index} 
              className="autocomplete-item"
              onClick={() => handleSelectOption(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </SearchContainer>
  );
};

export default SearchAutocomplete;
